import { motion } from "framer-motion";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as GrIcons from "react-icons/gr";
import { useMixpanel } from "react-mixpanel-browser";
import { useDispatch } from "react-redux";
import { useWizard } from "react-use-wizard";
import CurrencyFormatter from "../../../shared/currency-formatter";
import { variants } from "../../../shared/variants";
import { stepActions } from "../../../store/Steps";

function CovertDetails({ setCurrentScreen }: any) {
  const { t } = useTranslation();
  const { previousStep, nextStep, goToStep } = useWizard();
  const dispatch = useDispatch();
  const q: any = sessionStorage.getItem("quote") || {};
  const quote = JSON.parse(q);

  const startDate = sessionStorage.getItem("startDate");
  const endDate = sessionStorage.getItem("endDate");
  const travel_type = sessionStorage.getItem("travel_type");

  const mixpanel = useMixpanel();

  useEffect(() => {
    if (mixpanel.config.token) {
      mixpanel.track("PageView", {
        pageName: "Travel|Cover-summary",
      });
    }
  }, [mixpanel]);

  return (
    <div className="container">
      <motion.div
        variants={variants}
        initial="enter"
        animate="center"
        exit={{ opacity: 0 }}
        className="steps-conatiner2"
      >
        <div className="center-div"></div>
        <div className="reg-title text-center">
          <span className="span-title-primary">{t("covertDetails.beforePurchasing")}</span> <br />
          {t("covertDetails.confirmAllGood")}
        </div>
        <br />
        <div className="confirmation-container">
          <div className="confirmation-wapper">
            <div className="conf-sect-group mb-2">
              <div className="conf-b-group-title mb-1">{t("covertDetails.coverDetails")}</div>
              <div className="d-flex justify-content-between">
                <span className="conf-keys">{t("covertDetails.plan")}</span>
                <span className="conf-keys">{t("covertDetails.basic")}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span className="conf-keys">{t("covertDetails.underwriter")}</span>
                <span className="conf-keys">{quote.insurerName}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span className="conf-keys">{t("covertDetails.cover")}</span>
                <span className="conf-keys">{travel_type}</span>
              </div>
              {/* <div className="d-flex justify-content-between">
                <span className="conf-keys">Cover Limit</span>
                <span className="conf-keys"><CurrencyFormatter
                    value={quote.coverLimit}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    suffix={" Ksh"}
                  /></span>
              </div> */}
            </div>

            <div className="mt-4">
              {/* <div className="cr-line"></div> */}
              <div className="d-flex justify-content-between">
                <div className="conf-b-group-title mb-1 mt-1">{t("covertDetails.basePrice")} </div>
                <div className="conf-b-group-title mb-1 mt-1">
                  <CurrencyFormatter
                    value={quote.amount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    suffix
                  />
                </div>
              </div>
              <div className="cr-line"></div>
            </div>

            <div className="conf-sect-group mb-2 mt-4">
              <div className="conf-b-group-title mb-1">{t("covertDetails.time")}</div>
              <div className="d-flex justify-content-between">
                <span className="conf-keys">{t("covertDetails.startDate")}</span>
                <span className="conf-keys">{startDate}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span className="conf-keys">{t("covertDetails.endDate")}</span>
                <span className="conf-keys">{endDate}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span className="conf-keys">{t("covertDetails.policyDuration")}</span>
                <span className="conf-keys">{t("covertDetails.days", { count: quote.policy.coverDays })}</span>
              </div>
            </div>

            <div className="conf-sect-group gr-tot mb-2 mt-5">
              <div className="d-flex justify-content-between">
                <span className="con-amt-bld">{t("covertDetails.amount")}</span>
                <span className="con-amt-bld">
                  <CurrencyFormatter
                    value={quote.amount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    suffix
                  />
                </span>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-5">
            <div className="previous">
              <span
                onClick={(e) => {
                  sessionStorage.setItem(
                    "details-screen",
                    "Beneficiary-screen",
                  );
                  dispatch(stepActions.onRemoveStep());
                  previousStep();
                }}
              >
                <span className="GrIcon me-2">
                  <GrIcons.GrFormPreviousLink />
                </span>{" "}
                <span className="previous">{t("covertDetails.previous")}</span>
              </span>
            </div>
            <div
              onClick={() => {
                sessionStorage.setItem(
                  "summary-confirmation-screen",
                  "personal-information",
                );
                setCurrentScreen("personal-information");
              }}
            >
              <button className="next-btn">
                {" "}
                <span>
                  {t("covertDetails.next")}{" "}
                  <span className="GrIcon ms-3">
                    <GrIcons.GrFormNextLink />
                  </span>
                </span>{" "}
              </button>
            </div>
          </div>
        </div>
        <br />
        <br />
      </motion.div>
    </div>
  );
}

export default CovertDetails;
